import { FC, ReactNode } from "react";
import TextField from "@mui/material/TextField";

export interface TextareaProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  /** Shown under the field while there is no error. */
  helperText?: ReactNode;
  disabled?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  rows?: number;
  placeholder?: string;
}

export const Textarea: FC<TextareaProps> = ({
  label,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  required,
  autoFocus,
  rows = 3,
  placeholder,
}) => (
  <TextField
    label={label}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    onBlur={onBlur}
    error={!!error}
    helperText={error ?? helperText}
    disabled={disabled}
    required={required}
    autoFocus={autoFocus}
    multiline
    rows={rows}
    size="small"
    fullWidth
    placeholder={placeholder}
  />
);

export default Textarea;
